import { useFormik } from 'formik';
import React from 'react';
import Select from 'react-select';
import Form from 'react-bootstrap/Form';
import { useDispatch } from 'react-redux';
import { AddDynamicForm } from '../../../../store/NTX/FlexValue/Form/formSlice';
// import {
//   DynamicFormSchema,
//   formJob,
// } from "../../../ValidationForm/validationSchema";
import { useTranslation } from 'react-i18next';

import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
// import useGetStaticFormList from "../../../../hooks/Forms/use-get-StaticForm";
import useGetExtraInformationTablesForm from '../../../../hooks/Forms/useGetExtraInformationTablesForm';
import useLookupModule from '../../../../hooks/Lookups/use-Lookup-Module';
import { DynamicFormExtraInfoSchema } from '../../../ValidationForm/validationSchema';

const AddExtraInformationForm = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { Module } = useLookupModule();

  const { dataExtraInformationTablesFormList } = useGetExtraInformationTablesForm();

  const formik = useFormik({
    initialValues: {
      IdStaticForm: '',
      isStatic: false,
      name2: '',
      name: '',
      icon: null,
      moduleId: '',
      dynamicFormTypesId: 2, // 2 Extra Information
      tableId: '',
    },
    validationSchema: DynamicFormExtraInfoSchema(t),
    onSubmit: (values) => {
      dispatch(
        AddDynamicForm({
          name2: values.name2,
          name: values.name,
          moduleId: values.moduleId,
          icon: values.icon,
          isStatic: values.isStatic,
          dynamicFormTypesId: values.dynamicFormTypesId,
          tableId: values.tableId,
          // tableId : "cd5aa419-0e0b-48fe-a66f-f004d97964a2"
        })
      )
        .unwrap()
        .then(() => {
          document.getElementById('closeModalForm').click();
          formik.resetForm();
          CustomAlert({ action: 'Add' });
        })
        .catch((error) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit}>
      <div className="row">
        <div className="col-xl-6">
          <div className="form-group mb-3">
            <label className="form-label">{t('LocalName')}</label>
            <Form.Control
              className="form-control"
              type="text"
              autoComplete="off"
              name="name2"
              onChange={formik.handleChange}
              value={formik.values.name2}
              isInvalid={formik.touched.name2 && formik.errors.name2}
            />
            <Form.Control.Feedback type="invalid">{formik.errors.name}</Form.Control.Feedback>
          </div>
        </div>

        <div className="col-xl-6">
          <div className="form-group mb-3">
            <label className="form-label">{t('GlobalName')}</label>
            <Form.Control
              className="form-control"
              type="text"
              autoComplete="off"
              name="name"
              onChange={formik.handleChange}
              value={formik.values.name}
              isInvalid={formik.touched.name && formik.errors.name}
            />
            <Form.Control.Feedback type="invalid">{formik.errors.name2}</Form.Control.Feedback>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-xl-6">
          <div className="form-group mb-3">
            <label className="form-label">{t('Application')}</label>
            <Form.Select
              className="form-select"
              name="moduleId"
              value={formik.values.moduleId}
              onChange={formik.handleChange}
              isInvalid={formik.touched.moduleId && formik.errors.moduleId}>
              <option value="">{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
              {Module &&
                Module?.map((item, idx) => (
                  <option key={++idx} value={item.id}>
                    {i18n.language === 'ar' ? item.name2 : item.name}
                  </option>
                ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">{formik.errors.moduleId}</Form.Control.Feedback>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="form-group mb-3">
            <label className="form-label">{t('Tables')}</label>
            <Select
              classNamePrefix="react-select"
              isSearchable={true}
              options={dataExtraInformationTablesFormList}
              onChange={(option) => formik.setFieldValue('tableId', option.value)}
              placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
            />
            {formik.errors.tableId && formik.touched.tableId && (
              <div style={{ color: 'red' }}>{formik.errors.tableId}</div>
            )}
          </div>
        </div>
      </div>

      <hr />
      <div className="d-flex gap-2">
        <button disabled={formik.isSubmitting} type="submit" className="btn btn-lg btn-theme w-100">
          {formik.isSubmitting ? (
            <div className="spinner-border spinner-border-sm me-2"></div>
          ) : (
            <i className="fas fa-lg fa-fw me-2 fa-plus"></i>
          )}
          {t('Add')}
        </button>

        <button
          type="button"
          className="btn btn-lg btn-default w-100"
          data-bs-dismiss="modal"
          id="closeModalForm">
          <i className="fa fa-power-off fa-fw me-1"></i> {t('Cancel')}
        </button>
      </div>
    </Form>
  );
};

export default AddExtraInformationForm;
